import { lazy, Suspense } from 'react';

import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import AuthGuard from '../guards/Authguard';
import DefaultLayout from '../layout/DefaultLayout';
import ErrorPage from '../ui-components/ErrorPage';
import PageWithTitle from '../ui-components/PageWithTitle';
import { FullPageLoader } from '../ui-components/Loader';

import protectedRoutes from './ProtectedRoutes';
import ProtectedRoutes from './ProtectedRoutesLegacy';
import RouteShell from './RouteShell';

const Login = lazy(() => import('../modules/auth/LoginPage'));
const ForgotPassword = lazy(() => import('../modules/auth/ForgotPasswordPage'));
const SetPassword = lazy(() => import('../modules/auth/SetPasswordPage'));
const VerifyEmail = lazy(() => import('../modules/auth/VerifyEmailPage'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: <PageWithTitle title="Login" component={Login} />,
  },
  {
    path: '/forgot-password',
    element: (
      <PageWithTitle title="Forgot Password" component={ForgotPassword} />
    ),
  },
  {
    path: '/set-password/forgot/:token',
    element: <PageWithTitle title="Set Password" component={SetPassword} />,
  },
  {
    path: '/verify-email/:code',
    element: <PageWithTitle title="Verify Email" component={VerifyEmail} />,
  },
  {
    element: <ProtectedRoutes />,
    children: [
      {
        element: <DefaultLayout />,
        children: [
          ...protectedRoutes.map((route) => ({
            path: route.path,
            element: (
              <AuthGuard required={route.meta.permission}>
                <RouteShell route={route} />
              </AuthGuard>
            ),
          })),
          {
            path: '/*',
            element: (
              <PageWithTitle title="404 Not Found" component={ErrorPage} />
            ),
          },
        ],
      },
    ],
  },
]);

const AppRouter = () => {
  return (
    <Suspense fallback={<FullPageLoader />}>
      <RouterProvider
        router={router}
        future={{
          v7_startTransition: true,
        }}
      />
    </Suspense>
  );
};

export default AppRouter;
